export const book = {
  editContractParticipant: 'editContractParticipant',
  inviteContractParticipant: 'inviteContractParticipant',
  contractQRCode: 'qr',
};
